import { ClerkProvider } from "@clerk/nextjs";
import { type PropsWithChildren, memo } from "react";

import { ClerkErrorBoundary } from "@/components/auth/ClerkErrorBoundary";
import { AuthContext } from "@/data/auth/auth.context";
import { useClerkErrorHandler } from "@/hooks/useClerkErrorHandler";

export const AuthClerkProvider = memo(({ children }: PropsWithChildren) => {
  const { handleClerkError } = useClerkErrorHandler();

  return (
    <ClerkProvider>
      <ClerkErrorBoundary onError={(error) => handleClerkError(error, "AuthClerkProvider")}>
        <AuthContext.Provider shouldPerformSync>{children}</AuthContext.Provider>
      </ClerkErrorBoundary>
    </ClerkProvider>
  );
});

AuthClerkProvider.displayName = "AuthClerkProvider";
